import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ShieldCheck, ArrowRight } from 'lucide-react';
export const VerifyOtp = () => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [timeLeft, setTimeLeft] = useState(120);
  useEffect(() => {
    if (timeLeft > 0) {
      const timerId = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(timerId);
    }
  }, [timeLeft]);
  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s.toString().padStart(2, '0')}`;
  };
  const handleChange = (element: HTMLInputElement, index: number) => {
    if (isNaN(Number(element.value))) return false;
    const newOtp = [...otp];
    newOtp[index] = element.value;
    setOtp(newOtp);
    if (element.nextSibling && element.value !== '') {
      ;
      (element.nextSibling as HTMLInputElement).focus();
    }
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    navigate('/dashboard/buyer');
  };
  return <div className="min-h-screen flex items-center justify-center bg-neutral-light p-4" data-id="element-1159">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-xl border border-neutral-200 p-8 md:p-10 text-center" data-id="element-1160">
        <div className="w-16 h-16 rounded-2xl bg-secondary/10 flex items-center justify-center mx-auto mb-6 border border-secondary/20" data-id="element-1161">
          <ShieldCheck size={32} className="text-secondary" data-id="element-1162" />
        </div>

        <h1 className="text-2xl font-serif font-bold text-primary-900 mb-2" data-id="element-1163">
          Verify your identity
        </h1>
        <p className="text-text-light mb-8" data-id="element-1164">
          We've sent a 6-digit verification code to{' '}
          <strong className="text-text" data-id="element-1165">john@example.com</strong>
        </p>

        <form onSubmit={handleSubmit} className="space-y-8" data-id="element-1166">
          <div className="flex justify-center gap-2 sm:gap-3" data-id="element-1167">
            {otp.map((data, index) => <input className="w-10 h-12 sm:w-12 sm:h-14 text-center text-xl font-bold rounded-xl border border-neutral-200 bg-neutral-50 focus:bg-white focus:ring-2 focus:ring-primary-900 outline-none transition-all" type="text" name="otp" maxLength={1} key={index} value={data} onChange={e => handleChange(e.target, index)} onFocus={e => e.target.select()} required data-id="element-1168" />)}
          </div>

          <button type="submit" className="w-full bg-primary-900 hover:bg-primary-800 text-white py-4 rounded-xl font-bold transition-colors flex items-center justify-center gap-2 shadow-lg" data-id="element-1169">
            Verify & Continue <ArrowRight size={18} data-id="element-1170" />
          </button>
        </form>

        <div className="mt-8 text-sm" data-id="element-1171">
          {timeLeft > 0 ? <p className="text-text-light" data-id="element-1172">
              Resend code in{' '}
              <strong className="text-primary-900" data-id="element-1173">
                {formatTime(timeLeft)}
              </strong>
            </p> : <button className="font-bold text-secondary hover:text-secondary-dark transition-colors" data-id="element-1174">
              Resend Verification Code
            </button>}
        </div>
      </div>
    </div>;
};